<template>
    <div>
        <playerHonorList :sport_id="sport_id"></playerHonorList>
    </div>
</template>

<script>

import playerHonorList from '@/components/ballsports/player_honor/list.vue';

export default {
    components: {
        playerHonorList
    },
    data () {
        let self = (window.x = this)
        return {
            sport_id: 1,
        }
    },
    methods: {
    },
    mounted () {
    },
    watch: {},
    computed: {}
}
</script>